import { render } from "./GuideScreenshots.vue?vue&type=template&id=96d5ff2c&scoped=true"
import script from "./GuideScreenshots.vue?vue&type=script&lang=js"
export * from "./GuideScreenshots.vue?vue&type=script&lang=js"

import "./GuideScreenshots.vue?vue&type=style&index=0&id=96d5ff2c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96d5ff2c"]])

export default __exports__